import React from 'react';

import { Flex } from '@atlaskit/primitives';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { Skeleton } from '@atlassian/eoc-skeleton';

export const ActionButtonsSkeleton = () => {
	return (
		<UFOLoadHold name="heartbeats-action-buttons-loading">
			<Flex gap="space.050">
				<Skeleton width="185px" height={4} />
				<Skeleton width="160px" height={4} />
			</Flex>
		</UFOLoadHold>
	);
};

export const BottomBarSkeleton = () => {
	return (
		<UFOLoadHold name="heartbeats-bottom-bar-loading">
			<Flex gap="space.400" direction="column">
				<Skeleton width="75%" height={2.25} />
				<Flex gap="space.200">
					<Skeleton width="10%" height={2.25} />
					<Skeleton width="20px" height={2.25} />
				</Flex>
			</Flex>
		</UFOLoadHold>
	);
};

export const ContentSkeleton = () => {
	return (
		<UFOLoadHold name="heartbeats-content-loading">
			<Skeleton width="100%" height={18} />
		</UFOLoadHold>
	);
};
